var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftArrowCircleFilled = function SvgLeftArrowCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#020060",
    d: "M1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m16.172 10-4.922 4.102V10.75H4.5v-1.5h6.75V5.898zm-3.422.898L13.828 10l-1.078-.898z",
    clipRule: "evenodd"
  })));
};
export { SvgLeftArrowCircleFilled as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDEwQzEgNS4wMjk0NCA1LjAyOTQ0IDEgMTAgMUMxNC45NzA2IDEgMTkgNS4wMjk0NCAxOSAxMEMxOSAxNC45NzA2IDE0Ljk3MDYgMTkgMTAgMTlDNS4wMjk0NCAxOSAxIDE0Ljk3MDYgMSAxMFoiIGZpbGw9IiMwMjAwNjAiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi4xNzE5IDEwTDExLjI1IDE0LjEwMTZWMTAuNzVINC41VjkuMjVIMTEuMjVWNS44OTg0NEwxNi4xNzE5IDEwWk0xMi43NSAxMC44OTg0TDEzLjgyODEgMTBMMTIuNzUgOS4xMDE1NlYxMC44OTg0WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";